<ng-container [ngSwitch]="headerStatus">
  <div class="search-header-box">
    <df-header-before-logged-in *ngSwitchCase="headerStatusEnum.BEFORE_LOGGED_IN"></df-header-before-logged-in>
    <df-header-after-logged-in [currentUser]="currentUser" *ngSwitchCase="headerStatusEnum.AFTER_LOGGED_IN"></df-header-after-logged-in>
  </div>
</ng-container>
